import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { StyledMapContainer, StyledMap, StyledMapWrapper } from "./styled";
import Input from "../Input";
import FormLabel from "../FormLabel";
import { makeStyles } from "../../utils/styles";
import marker_icon from "../../assets/images/map_marker.svg";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((css) => ({
    addressInput: css`
        margin-bottom: 25px;
    `,
}));

const Map = ({
    name,
    currentLocation,
    onFindPlace,
    readonly,
    error,
    errorText,
}) => {
    const { t } = useTranslation();
    const styles = useStyles();
    const google = window.google;
    const refMap = useRef(null);
    const refInput = useRef(null);
    const searchBox = useRef(null);

    useEffect(() => {
        if (refMap.current && refInput.current && google.maps) {
            const map = new google.maps.Map(refMap.current, {
                zoom: 17,
                center: { lat: -33.8688, lng: 151.2195 },
                disableDefaultUI: true,
                scrollwheel: false,
                navigationControl: false,
                mapTypeControl: false,
                scaleControl: false,
                draggable: false,
                clickableIcons: false,
                draggableCursor: "initial",
            });

            const input = refInput.current;
            searchBox.current = new google.maps.places.Autocomplete(input);

            searchBox.current.bindTo("bounds", map);

            const marker = new google.maps.Marker({
                map,
                anchorPoint: new google.maps.Point(0, -29),
                clickable: false,
                icon: marker_icon,
            });

            //Set marker on init
            if (currentLocation) {
                const myLatLng = new google.maps.LatLng(currentLocation);

                map.setCenter(myLatLng);
                map.setZoom(17);

                marker.setPosition(myLatLng);
                marker.setVisible(true);
            }

            const placeChange = () => {
                const place = searchBox.current.getPlace();
                if (!place.geometry) {
                    return;
                }

                onFindPlace(name, {
                    address: place.formatted_address,
                    lat: place?.geometry.location.lat(),
                    lng: place?.geometry.location.lng(),
                });

                if (place.geometry.viewport) {
                    map.fitBounds(place.geometry.viewport);
                } else {
                    map.setCenter(place.geometry.location);
                    map.setZoom(17); // Why 17? Because it looks good.
                }

                marker.setPosition(place.geometry.location);
                marker.setVisible(true);
            };

            searchBox.current.addListener("place_changed", placeChange);
        }

        return () =>
            google.maps.event.clearInstanceListeners(searchBox.current);
        // eslint-disable-next-line
    }, []);
    return (
        <StyledMapWrapper>
            <Input
                ref={refInput}
                placeholder={t("Adres")}
                label={t("Adres")}
                customStyle={styles.addressInput}
                readonly={readonly}
                defaultValue={currentLocation?.address}
                error={!!error}
                errorText={errorText}
            />
            <StyledMapContainer readonly={readonly}>
                <FormLabel>{t("Lokalizacja")}</FormLabel>
                <StyledMap ref={refMap} />
            </StyledMapContainer>
        </StyledMapWrapper>
    );
};

Map.propTypes = {
    name: PropTypes.string,
    currentLocation: PropTypes.object,
    onFindPlace: PropTypes.func,
    readonly: PropTypes.bool,
};

Map.defaultProps = {
    name: "location",
    currentLocation: null,
    onFindPlace: undefined,
    readonly: false,
};

export default React.memo(Map);
